export default {
      id: "cloud-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#cloud",
      toString: function () {
        return this.url;
      }
    }